import { useEffect, useState } from 'react';
import Styles from '../../assets/css/components/company/company.module.scss';
import CompanyTable from '../company/CompanyList';
import { useNavigate } from 'react-router-dom';
import { companyList } from '../../services/Api';
import Loader from '../../utils/Loader';

const Company = () => {
  const navigate = useNavigate();

  const [companies, setCompanies] = useState([]);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [totalSku, setTotalSku] = useState(0);
  const [loading, setLoading] = useState(true);

  // ✅ Number formatter for Singapore locale (1K, 1.2M)
  const formatCompactNumber = (num) => {
    if (num === null || num === undefined || isNaN(num)) return '0';
    return new Intl.NumberFormat('en-SG', {
      notation: 'compact',
      compactDisplay: 'short',
      maximumFractionDigits: 2, // e.g. 1.23M
    }).format(num);
  };

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        setLoading(true);
        const response = await companyList({ page: 1 });

        setCompanies(response.data || []);
        setTotalCustomers(response.total_customers || 0);
        setTotalSku(response.total_sku || 0);
      } catch (error) {
        console.error('Error fetching companies:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  return (
    <div className={`${Styles.company}`}>
      <div className={`${Styles.company_heading}`}>
        <h2>Company</h2>
        <button className={`${Styles.add_btn}`} onClick={() => navigate("/company/create")}>Add new Company</button>
      </div>

      {loading ? (
        <div className={Styles.loader_container}>
          <Loader size="large" color="primary" />
        </div>
      ) : (
        <>
          <div className={`${Styles.cards}`}>
            <div className={`${Styles.card}`}>
              <p>Total customers</p>
              <h3>{formatCompactNumber(totalCustomers)}</h3>
            </div>
            <div className={`${Styles.card}`}>
              <p>Total SKUs</p>
              <h3>{formatCompactNumber(totalSku)}</h3>
            </div>
          </div>

          <div>
            <CompanyTable companies={companies} />
          </div>
        </>
      )}
    </div>
  );
};

export default Company;
